// src/belediye/nav.js
//
// NAV SÖZLEŞMESİ (FAZ-12) — menü = guard TEK LİSTE.
// Bu dosya sayfa envanterinin tek kaynağıdır: izinli sidebar buradan beslenir,
// FAZ-13 route guard'ları da BU listeden okuyacak.
//
// Alanlar:
//   group        : sidebar grubu başlığı (bugünkü görsel gruplama korunur)
//   page         : benzersiz sayfa anahtarı
//   href         : relative ise basePath'e eklenir; "/" ile başlıyorsa mutlak
//   permissions  : canAny() ile değerlendirilir (herhangi biri yeterli)
//   workspace    : sayfanın kabuk kimliği — "belediye" | "halk-masasi" | "saha" | "sistem".
//                  BİRLEŞİK SIDEBAR (2026-07-05): sidebar artık kullanıcının izinli
//                  olduğu TÜM grupları gösterir (visibleNav unified=true). workspace
//                  alanı yalnız "hangi sidebar GRUBU + hangi kabuk stili" için kalır;
//                  erişimi izinler belirler. (unified=false eski tek-workspace davranışı
//                  geriye uyumlu durur — FAZ-13 guard envanteri vb.)
//   inMenu       : false → sidebar'da GÖSTERİLMEZ, yalnız FAZ-13 guard envanteri
//                  (dashboard/bildirimler bugün sidebar'da değil; parite korunur).
//
// KARAR NOTU (FAZ-12 MD 3.1): bugünkü "Görev Atama" sidebar linki ÖLÜ
// placeholder'dır — NAV'a alınmadı; izinli yolda Operasyon grubu düşer
// (bilinçli, MD'de kayıtlı tek görsel fark).

export const NAV = [
  // Sidebar'da olmayan, guard envanteri için sayfalar (FAZ-13):
  { group: "Genel Yönetim", page: "dashboard", href: "dashboard", permissions: ["dashboard.view"], workspace: "belediye", inMenu: false },
  { group: "Sistem", page: "bildirimler", href: "bildirimler", permissions: ["notifications.view"], workspace: "belediye", inMenu: false },

  // Başvuru Yönetimi — 4 statü sayfası TEK sekmeli "Başvurular" ekranında birleşti
  // (statü değişimi sayfa içi sekmelerle). Sidebar'da yalnız "Başvurular" +
  // "Yönlendirilenler" kalır. Eski statü route'ları geriye-uyumlu çalışır ama
  // menüde yer almaz.
  // FAZ-22 ADIM-4b: sidebar link ÜRETİMİ canonical (birimSİZ). Birim localStorage+
  // scope'tan (resolveActiveUnit) çözülür; eski /yonetim/:unitSlug/... alias KALIR.
  // yonlendirilen + anketler'in birimSİZ canonical route'u YOK → relative (alias) bırakılır.
  { group: "Başvuru Yönetimi", page: "basvurular", href: "/yonetim/basvurular", permissions: ["applications.view"], workspace: "belediye", inMenu: true },
  { group: "Başvuru Yönetimi", page: "yonlendirilen", href: "/yonetim/yonlendirilen-basvurular", permissions: ["staff.forwardlog.report.view"], workspace: "belediye", inMenu: true },

  // Personel (FAZ-18 — modül-gate'li; izin runtime/admin'den atanır):
  { group: "Genel Yönetim", page: "personel", href: "/yonetim/personel", permissions: ["personel.directory.view"], workspace: "belediye", inMenu: true },

  // Analiz:
  { group: "Analiz", page: "raporlar", href: "/yonetim/raporlar", permissions: ["reports.view"], workspace: "belediye", inMenu: true },
  { group: "Analiz", page: "anketler", href: "/yonetim/anketler", permissions: ["surveys.report.view"], workspace: "belediye", inMenu: true },

  // Halk Masası (kendi kabuğu):
  { group: "Başvuru Yönetimi", page: "hm-yeni", href: "/yonetim/halk-masasi/yeni-basvuru", permissions: ["halk_masasi.application.create"], workspace: "halk-masasi", inMenu: true },
  { group: "Başvuru Sorgula", page: "hm-sorgu", href: "/yonetim/halk-masasi/sorgu", permissions: ["halk_masasi.citizen.search"], workspace: "halk-masasi", inMenu: true },

  // Saha (kendi kabuğu — sidebar'sız layout; FAZ-13 guard envanteri):
  { group: "Saha Talepleri", page: "gorevlerim", href: "saha", permissions: ["assignments.feedback.create"], workspace: "saha", inMenu: false },

  // FAZ-56 (2026-07-28) — Kurum İçi Görevler İKİYE AYRILDI (+ rapor).
  // Kapsam artık sekmeden değil SAYFADAN gelir:
  //   Görev Ata    → kişinin KENDİ verdiği görevler (+ view_all varsa tümü)
  //   Görevlerim   → kişiye ATANAN görevler (+ izinliyse Birim Havuzu çipi)
  //   Görev Raporu → sayısal özet + XLSX
  // Sayfa içindeki çipler yalnız STATÜ ifade eder. Menüde hangi maddenin
  // görüneceğini yalnız izinler belirler (rol string kontrolü YOK).
  //
  // TUZAK: "gorevlerim" sayfa anahtarı SAHA akışına ait (yukarıdaki satır) —
  // kurum içi sayfaya "gorev-bana" anahtarı verildi; rota yine /yonetim/gorevlerim.
  { group: "Operasyon", page: "gorev-ata", href: "/yonetim/gorev-ata", permissions: ["tasks.view_created", "tasks.view_all"], workspace: "belediye", inMenu: true },
  { group: "Operasyon", page: "gorev-bana", href: "/yonetim/gorevlerim", permissions: ["tasks.view_assigned", "tasks.view_unit_pool"], workspace: "belediye", inMenu: true },
  // NOT: "Görev Raporu" maddesi 2026-07-28'de KALDIRILDI (kullanıcı kararı:
  // "böyle bir istatistiğe gerek yok"). Kurum içi görevlerin menüde yalnız
  // İKİ maddesi vardır: Görev Ata (veren) ve Görevlerim (yapan).

  // Kurum İçi Mesajlaşma — tam sayfa (dock kartının "tam ekran" hedefi). Modül
  // (mesajlasma) KAPALIYKEN sidebar'da İZ BIRAKMAZ (BelediyeSidebar modül kapısı).
  // FAZ-52: "Mesajlar" SAYFASI kaldırıldı (kullanıcı kararı 2026-07-27).
  // Mesajlaşmanın tek yüzeyi sohbet penceresi (ChatDock) — her rotada erişilebilir;
  // ayrı bir tam sayfa liste aynı işi ikinci kez yapıyordu.

  // Sistem Yönetimi (kendi kabuğu — FAZ-15):
  { group: "Sistem Yönetimi", page: "sy-kullanicilar", href: "/yonetim/sistem/kullanicilar", permissions: ["users.view"], workspace: "sistem", inMenu: true },
  { group: "Sistem Yönetimi", page: "sy-roller", href: "/yonetim/sistem/roller", permissions: ["roles.manage", "permissions.catalog.view"], workspace: "sistem", inMenu: true },
  { group: "Sistem Yönetimi", page: "sy-birim-agaci", href: "/yonetim/sistem/birim-agaci", permissions: ["units.view", "units.manage", "units.manage_tree"], workspace: "sistem", inMenu: true },

  // FAZ-24 — yeni yönetim ekranları (izin-türevli; sistem kabuğu). Kullanıcı kararı:
  // vatandaş tarafını (kent haritası + mahalle dropdown'u) besleyen zincirli geo veri
  // (Mahalleler + İdari Sınırlar) AYRI "Kent & Harita" grubunda; Vatandaş kaydı ayrı grup.
  { group: "Kent & Harita", page: "sy-mahalleler", href: "/yonetim/sistem/mahalleler", permissions: ["neighborhoods.view"], workspace: "sistem", inMenu: true },
  { group: "Kent & Harita", page: "sy-idari-sinirlar", href: "/yonetim/sistem/idari-sinirlar", permissions: ["admin_boundaries.view"], workspace: "sistem", inMenu: true },
  { group: "Vatandaş Yönetimi", page: "sy-vatandaslar", href: "/yonetim/sistem/vatandaslar", permissions: ["citizens.view"], workspace: "sistem", inMenu: true },

  // profil: izinsiz, herkese — NAV dışı sabit öğe
];

/**
 * resolveLanding — login-sonrası iniş sayfası, İZİN-ÖNCELİK listesi
 * (FAZ-13 ADIM 2.1; 03-ekran kararı: landing = tek fonksiyon). SAF fonksiyon.
 *
 * Öncelik: dashboard → halk-masası → saha → başvurular → profil.
 * `permission_ui` KAPALIYKEN ÇAĞRILMAZ — eski rol tabanlı yönlendirme aynen.
 *
 * @param {string[]} permissions
 * @param {object}  ctx
 * @param {string}  ctx.scopeMode          /me.scope.mode ("all_units" | "member_units")
 * @param {string}  ctx.unitSlug           aktif/tek birim slug'ı (yoksa boş)
 * @param {boolean} ctx.needsUnitSelection çok üyelik VE birim seçilmemiş
 * @param {boolean} ctx.isSuperUser         /me.is_superuser (sistem dışı kök yetkili)
 */
export function resolveLanding(permissions, { scopeMode, unitSlug, needsUnitSelection = false, isSuperUser = false, uiProfile = null } = {}) {
  // Superuser = sistem dışı kök yetkili: BİRİM GEREKTİRMEZ ve başkanlık rotasına
  // (başkan ≠ superuser) DÜŞMEZ. Doğrudan Sistem Yönetimi'ne iner. Bu dal en üstte
  // olduğundan scope/birim durumundan bağımsızdır; uiOn=false'ta çağrılmaz (davranış korunur).
  if (isSuperUser) return "/yonetim/sistem/kullanicilar";

  const set = new Set(Array.isArray(permissions) ? permissions : []);
  const allUnits = scopeMode === "all_units";
  const base = allUnits
    ? "/yonetim/baskanlik"
    : unitSlug
    ? `/yonetim/${unitSlug}`
    : null;

  // FAZ-22 ADIM-4b: landing artık CANONICAL (birimSİZ) döner. Birim URL'e konmaz —
  // localStorage.activeUnitSlug + scope.mode'dan (resolveActiveUnit) çözülür; eski
  // /yonetim/:unitSlug/... alias'ları KALIR. Çok-üyelikli + birim seçilmemiş VEYA
  // hiç birim yok → /yonetim/birim-sec (eski güvenli düşüş korunur).
  const canonical = (path) => {
    if (!allUnits && needsUnitSelection) return "/yonetim/birim-sec";
    if (!base) return "/yonetim/birim-sec";
    return path;
  };

  // FAZ-20 — ui_profile landing önceliği (izin-öncelik listesinden ÖNCE ama
  // İZİNLE TEYİTLİ: profil yetki VERMEZ). halk_masasi/saha kullanıcısı, dashboard
  // izni olsa bile kendi deneyimine iner. Profil yoksa (undefined) bu dallar atlanır.
  if (uiProfile === "halk_masasi" && set.has("halk_masasi.citizen.search")) return "/yonetim/halk-masasi";
  if (uiProfile === "saha" && set.has("assignments.feedback.create")) return canonical("/yonetim/saha/gorevlerim");

  if (set.has("dashboard.view")) return canonical("/yonetim/dashboard");
  if (set.has("halk_masasi.citizen.search")) return "/yonetim/halk-masasi";
  // Saha inişi YALNIZ saf saha personeline (başvuru erişimi OLMAYAN). birim_personeli
  // gibi hem assignments.feedback.create hem applications.view olanlar başvurulara iner.
  if (set.has("assignments.feedback.create") && !set.has("applications.view") && !allUnits) return canonical("/yonetim/saha/gorevlerim");
  if (set.has("applications.view")) return canonical("/yonetim/basvurular");
  // FAZ-15: yalnız yönetim izinli kullanıcı (SY) → Sistem Yönetimi workspace'i.
  if (set.has("users.view") || set.has("roles.manage")) return "/yonetim/sistem/kullanicilar";
  // FAZ-22 4b tamamlama: profil artık birimSİZ canonical route'a sahip.
  return base ? "/yonetim/profil" : "/yonetim/birim-sec";
}

/**
 * visibleNav — saf fonksiyon (menü-snapshot testlerinin öznesi).
 *
 * @param {string[]} permissions  kullanıcının izin kodları
 * @param {object}   opts
 * @param {string}   opts.workspace  aktif kabuk (default "belediye")
 * @param {boolean}  opts.menuOnly   true → yalnız inMenu kalemler (sidebar);
 *                                   false → tüm guard envanteri (FAZ-13)
 * @returns NAV alt kümesi (sıra korunur)
 */
export function visibleNav(permissions, { workspace = "belediye", menuOnly = true, unified = false } = {}) {
  const set = new Set(Array.isArray(permissions) ? permissions : []);
  return NAV.filter((item) => {
    if (menuOnly && item.inMenu === false) return false;
    // BİRLEŞİK SIDEBAR: unified=true → workspace filtresi UYGULANMAZ; kullanıcı
    // hangi izne sahipse o grup görünür (rol/kabuk kilidi değil, izin). unified
    // değilse eski tek-workspace davranışı GERİYE UYUMLU korunur.
    if (!unified && item.workspace !== workspace) return false;
    return item.permissions.some((p) => set.has(p));
  });
}
